import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import { fetchByUserId } from 'Redux/actions/userPhotos';

@connect(
    (state) => ({
        userPhotos: state.userPhotos
    }), { fetchByUserId }
)
export default class SinglePhotoAuthorPhotos extends React.Component {
    static propTypes = {
        fetchByUserId: PropTypes.func.isRequired,
        user: PropTypes.shape({
            id: PropTypes.string.isRequired,
            username: PropTypes.string.isRequired,
            href: PropTypes.string.isRequired
        }).isRequired,
        onEnterPhoto: PropTypes.func,
        userPhotos: PropTypes.arrayOf(
            PropTypes.shape({
                isPending: PropTypes.bool.isRequired,
                isLoaded: PropTypes.bool.isRequired,
                userId: PropTypes.string.isRequired,
                photos: PropTypes.arrayOf(
                    PropTypes.shape({
                        id: PropTypes.string.isRequired,
                        href: PropTypes.string.isRequired,
                        selectedCaption: PropTypes.string.isRequired,
                        resolutions: PropTypes.shape({
                            lowest: PropTypes.string.isRequired
                        }).isRequired
                    })
                ).isRequired
            })
        ).isRequired
    };
    static defaultProps = {};

    componentDidMount = () => {
        const { user, fetchByUserId } = this.props;

        fetchByUserId({
            userId: user.id
        });
    }

    getCurrentUserPhotos = userPhotosMap => {
        const { user } = this.props;

        const currentUserPhotosIndex = userPhotosMap.findIndex(userPhotos => userPhotos.userId === user.id);
        return userPhotosMap[currentUserPhotosIndex];
    }

    renderPhoto = photo => {
        return (
            <Link to={photo.href} className="user-photo" key={photo.id} onClick={this.props.onEnterPhoto}>
                <img src={photo.resolutions.lowest} alt={photo.selectedCaption} />
            </Link>
        );
    }

    render() {
        const { userPhotos, user } = this.props;
        const currentUserPhotos = this.getCurrentUserPhotos(userPhotos);

        if (!currentUserPhotos) {
            //Dont render component if data hasnt start downloading yet
            return (null);
        } else if (!currentUserPhotos.isPending && currentUserPhotos.isLoaded && !currentUserPhotos.photos.length) {
            //Dont render component if there are no related photos
            return (null);
        }

        return (
            <div className="component-single-photo-author-photos">
                <div className="container-fluid">
                    <h2 className="title">
                        {I18n.t('SINGLE_PHOTO.authorPhotos.listTitle')}&nbsp;
                        <Link to={user.href}>{user.username}</Link>
                    </h2>
                    <div className="list-container custom-scrollbar">
                        <div className="list row">
                            {currentUserPhotos.photos.map(currentUserPhoto => this.renderPhoto(currentUserPhoto))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/single-photo/AuthorPhotos/index.js